export const FETCH_TOP_TEST_REQUEST = "FETCH_TOP_TEST_REQUEST";
export const FETCH_TOP_TEST_SUCCESS = "FETCH_TOP_TEST_SUCCESS";
export const FETCH_TOP_TEST_FAILURE = "FETCH_TOP_TEST_FAILURE";
export const SET_TOP_TEST_VALIDATION_ERRORS = "SET_TOP_TEST_VALIDATION_ERRORS";